interface Props {
  url: string;
}

export default function ExternalRedirect (props: Props) {
  window.location.replace(props.url);
  return null;
}
